module.exports = __webpack_public_path__ + "img/Enor_pearl_icon.d0a8f68b.png";